//@ts-strict-ignore
import React, { memo } from 'react';
import titleCase from '../../../utils/TitleCase';
import isFunction from '../../react-data-grid/utils/isFunction';
import WorkspaceStatusBadge from './WorkspaceStatusBadge';

const TextFieldFormatter = (props) => {
  if (props.value && Array.isArray(props.value)) {
    return <WorkspaceStatusBadge parentKey={props.key} value={props.value} />;
  }
  let value = props.value;

  const textFormat = props.column?.options?.textFormat;

  if (textFormat) {
    if (isFunction(textFormat)) {
      value = textFormat(value, props);
    } else if (textFormat === 'TITLE_CASE') {
      value = titleCase(value);
    }
  }

  let title = props.dependentValues.options.title;
  if (isFunction(title)) {
    title = title(props.dependentValues.rowData);
  }
  if (!title) {
    title = value;
  }

  return (
    <div key={props.key} title={title}>
      {value}
    </div>
  );
};

export default memo<any>(
  TextFieldFormatter,
  (prevProps, nextProps) => prevProps.value === nextProps.value && !nextProps?.dependentValues?.options?.forceUpdate
);
